import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import data from './data.jsx'
import { useStaticQuery, graphql } from 'gatsby'

import {
  Container,
  ContentSlider,
  CenteredTitle,
  CenteredP,
  SlickImage,
  TextoOver,
} from './style.css'

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  pauseOnDotsHover: true,
  centerMode: true,
  adaptiveHeight: true,
  rows: 1,
  draggable: true,
  arrows: false,
  autoplay: true,
  cssEase: 'linear',

  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}

const showContent = () => {
  // console.log('derp')
}

const Carousel = ({ titulo, bajada }) => {
  const images = useStaticQuery(graphql`
    query carouselImagesQuery {
      allFile(filter: { relativeDirectory: { eq: "comunidades" } }) {
        nodes {
          name
          childImageSharp {
            gatsbyImageData(
              width: 500
              height: 500
              quality: 80
              placeholder: BLURRED
              formats: [AUTO, WEBP]
              outputPixelDensities: [0.25, 1, 2]
            )
          }
        }
      }
    }
  `)
  return (
    <Container>
      <CenteredTitle className="text-white leading-none">
        {titulo}
      </CenteredTitle>
      <CenteredP className="text-white">{bajada}</CenteredP>
      <ContentSlider>
        <Slider {...settings}>
          {data.map(item => {
            const hasImage = images.allFile?.nodes?.find(
              image => image.name === item.slug,
            )
            const Logo = item.logo
            return (
              <SlickImage key={item.slug}>
                <div className="image-wrap" onClick={() => showContent()}>
                  {hasImage && (
                    <GatsbyImage image={getImage(hasImage)} alt="La Tercera" />
                  )}
                  <div className="logo-wrap">
                    <Logo className="logo" schema="light" />
                  </div>
                </div>
                <TextoOver>
                  <div className="caja-texto text-white">
                    {/* <h2>{item.slug}</h2> */}
                    <p>{item.description}</p>
                  </div>
                </TextoOver>
              </SlickImage>
            )
          })}
        </Slider>
      </ContentSlider>
    </Container>
  )
}

export default Carousel
